import { useState } from "react";
import { aiModels } from "@/mocks/aiAdmin";

interface TestResult {
  status: string;
  responseTime: number;
  model: string;
  success: boolean;
  output: string;
}

const testTargets = aiModels.filter((m) => m.id !== "embedding" && m.id !== "safety");

const presetTests: Record<string, string> = {
  tutor: "2+2 kaçtır?",
  vision: "Görseldeki matematik sorusunu çöz.",
  translate: "Although scientists had expected a different result, the data proved otherwise.",
  advanced: "Karmaşık bir limit problemini adım adım çöz.",
};

export default function ApiTestMerkezi() {
  const [target, setTarget] = useState<string>(testTargets[0]?.id ?? "tutor");
  const [message, setMessage] = useState<string>(presetTests.tutor);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<TestResult | null>(null);

  const selected = aiModels.find((m) => m.id === target);

  function runTest() {
    if (!selected) return;
    setLoading(true);
    setResult(null);

    // Model yanıt süresini ölçen test simülasyonu.
    setTimeout(() => {
      setLoading(false);
      setResult({
        status: "200 OK",
        responseTime: 1200 + Math.round(Math.random() * 1800),
        model: selected.modelId,
        success: true,
        output: "Test başarılı. Model bağlantısı ve yanıt süresi doğrulandı.",
      });
    }, 1400);
  }

  return (
    <div className="space-y-6">
      <div className="rounded-lg border border-background-200 bg-background-50 p-6 max-w-2xl">
        <h3 className="font-heading font-semibold text-base text-foreground-950">Model Seç</h3>
        <div className="mt-3 flex flex-wrap gap-2">
          {testTargets.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => {
                setTarget(t.id);
                setMessage(presetTests[t.id] ?? "");
                setResult(null);
              }}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                target === t.id
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {t.name}
            </button>
          ))}
        </div>

        <label className="block mt-5">
          <span className="text-sm font-medium text-foreground-700">Test Mesajı</span>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={3}
            className="mt-2 w-full rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-900 focus:outline-none focus:border-accent-400 resize-none"
          />
        </label>

        <button
          type="button"
          onClick={runTest}
          disabled={loading || !message.trim()}
          className="mt-4 px-6 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {loading ? "Test Ediliyor..." : "TEST ET"}
        </button>
      </div>

      {result && (
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 max-w-2xl">
          <h3 className="font-heading font-semibold text-base text-foreground-950">Sonuç</h3>
          <dl className="mt-4 space-y-2 text-sm">
            <div className="flex justify-between gap-4">
              <dt className="text-foreground-500">API Status</dt>
              <dd className={`font-medium ${result.success ? "text-emerald-600" : "text-red-600"}`}>{result.status}</dd>
            </div>
            <div className="flex justify-between gap-4">
              <dt className="text-foreground-500">Response Time</dt>
              <dd className="text-foreground-800">{(result.responseTime / 1000).toFixed(1)} saniye</dd>
            </div>
            <div className="flex justify-between gap-4">
              <dt className="text-foreground-500">Model</dt>
              <dd className="text-foreground-800 break-all">{result.model}</dd>
            </div>
            <div className="flex justify-between gap-4">
              <dt className="text-foreground-500">Sonuç</dt>
              <dd className={`font-medium ${result.success ? "text-emerald-600" : "text-red-600"}`}>
                {result.success ? "başarılı" : "başarısız"}
              </dd>
            </div>
          </dl>
          <div className="mt-4 rounded-md bg-background-100 p-4 text-sm text-foreground-700">
            {result.output}
          </div>
        </div>
      )}
    </div>
  );
}